<template>
  <span>
    <span v-if="isMobile">
      <a :href="item.fileUrl" target="_blank">{{item.fileName}}</a>
    </span>
    <span v-else>
      <a v-if="isOfficeFile(item.fileType)" target="_blank" :href="'https://view.officeapps.live.com/op/view.aspx?src='+item.fileUrl">{{item.fileName}}</a>
      <a v-else-if="isPDF(item.fileType)" target="_blank" :href="baseURL+'/common/pdf/preview?dz='+item.fileUrl">{{item.fileName}}</a>
      <a v-else :href="encodeURI(item.fileUrl)" target="_blank">{{item.fileName}}</a>
    </span>
  </span>
</template>
<script>
  import {
    mapState
  } from "vuex";
  export default {
    props: ['item'],
    computed: {
      ...mapState({
        isMobile: state => state.main.isMobile,
      })
    },
    data() {
      return {
        baseURL: axios.defaults.baseURL
      }
    },
    methods: {
      isPDF(type) {
        if (type == 'pdf') {
          return true
        } else {
          return false
        }
      },
      isOfficeFile(type) {
        switch (type) {
          case 'doc':
          case 'docx':
          case 'xls':
          case 'xlsx':
          case 'ppt':
          case 'pptx':
            return true
            break;
          default:
            return false
            break;
        }
      },
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/FileLink.vue